import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import edit from "../../../picture/editing.png";
import cancel from "../../../picture/cancel.png";
import check from "../../../picture/check.png";
import AuthService from "../../../services/auth.service";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import PaginationS from "../../admin/Pagination";
import Static_modal from "../etc/Static_modal";
import { useLanguage } from "../../../Language/LanguageContext";
const PilotStatus = () => {
  let Navigate = useNavigate();
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  const [data, setData] = useState([""]);
  const [deletingSelect, setDeletingSelect] = useState([]);
  const [showDeletePilot, setShowDeletePilot] = useState(false);
  const [remoteDrone, setRemoteDrone] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  // const [remoteDrone, setRemoteDrone] = useState([
  //   {
  //     id: 0,
  //     code: 0,
  //     name: "",
  //     type: "",
  //     status: "",
  //   },
  // ]);
  const [pilotSearchResult, setPilotSearchResult] = useState(undefined);
  const [currnetChoosing, setCurrentChoosing] = useState();
  const [searchPilot, setSearchPilot] = useState(false);
  const [addsuc, setAddsuc] = useState(false);
  const [connectrid, setconnectrid] = useState(false);
  const [idpilot, setIdpilot] = useState("");
  const [codepilot, setCodepilot] = useState("");
  const [pilotdata, setPilotdata] = useState("");
  const [checkope, setCheckope] = useState(false);
  const [yes_error, setYes_error] = useState("");
  const [errorpilot, setErrorpilot] = useState();
  const [dataerror, setDataerror] = useState("");
  const createPost = (req_num) => {
    console.log(req_num);
    Navigate("/user/drone/statusDroneSec", {
      state: {
        drone_id: req_num,
      },
    });
  };
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const checkoperator = () => {
    const operatorid = sessionStorage.getItem("operator_id");
    if (operatorid === "null" || operatorid === undefined) {
      setCheckope(true);
      // setTimeout(() => {
      //   setCheckope(false);

      //   Navigate("/home");
      //   window.location.reload(false);
      // }, 2000);
    } else {
      //const check = AuthServiceV2.NewToken();
      getpilot();
    }
  };
  const getpilot = () => {
    AuthServiceV2.PilotlistforO()
      .then((res) => {
        console.log(res);
        if (res.data.status === "error") {
          setYes_error(true);
          console.log("sss");
          setLoading(false);
        } else {
          let listdata = [];

          const results = res.data.pilot_data
            .filter((item) => item.pilot_type === "SPECIFIC") // กรองเฉพาะที่มี pilot_type === "SPECIFIC"
            .map((item) => item.pilot_id); // ดึงเฉพาะค่า pilot_id ออกมา

          for (let i = 0; i < res.data.pilot_data.length; i++) {
            if (
              results.indexOf(res.data.pilot_data[i].pilot_id) != -1 &&
              res.data.pilot_data[i].pilot_type === "OPEN"
            ) {
            } else {
              listdata.push(res.data.pilot_data[i]);
            }
          }

          setRemoteDrone(listdata);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const deletePilot = (pilot_id, co_id) => {
    const deletePilot = AuthServiceV2.OperemovePilot(pilot_id, co_id);
    if (deletePilot != null) {
      deletePilot
        .then((res) => {
          console.log(res);
          window.location.reload(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const findPilot = () => {
    const check = AuthServiceV2.FindpilotforO(idpilot, codepilot);
    if (check != null) {
      check
        .then((res) => {
          console.log(res);
          if (res === "Invalid pilot code") {
            setYes_error(true);
            console.log("sss");
          } else if (
            res === "The pilot id field must be an integer. (and 1 more error)"
          ) {
            setYes_error(true);
            console.log("sss");
          } else if (res === "The pilot id field must be an integer.") {
            setYes_error(true);
            console.log("sss");
          } else if (
            res === "The pilot id field is required. (and 1 more error)"
          ) {
            setYes_error(true);
            console.log("sss");
          } else if (res === "The pilot code field is required.") {
            setYes_error(true);
            console.log("sss");
          } else if (res === "The pilot id field is required.") {
            setYes_error(true);
            console.log("sss");
          } else {
            setPilotdata(res.data.pilot_data);
            console.log(res.data);
          }
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const addpilot = () => {
    const check = AuthServiceV2.AddpilotforO(idpilot, codepilot);
    if (check != null) {
      check
        .then((res) => {
          console.log(res);
          window.location.reload(false);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });

          if (error.response) {
            // The request was made and the server responded with a status code

            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            setDataerror(error.response.data.error_description);
            setErrorpilot(true);
          } else if (error.request) {
            // The request was made but no response was received
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an error
            console.log("Error", error.message);
          }
        });
    }
  };
  useEffect(() => {
    const check = AuthServiceV2.NewToken();

    setTimeout(() => {
      checkoperator();
    }, 2000);
  }, []);
  const { state } = useLocation();
  const [SearchValue, setSeachValue] = useState(["pilot_name"]);
  const [portionData, setPortionData] = useState([]);
  const [startArr, setStartArr] = useState(0);
  const handlePortionChange = (newPortion, startarr) => {
    setPortionData(newPortion);
    setStartArr(startarr);
  };

  return (
    <>
      <div className="container-main">
        <div className="table-card-header">
          <h4 className="header-main" style={{ color: "white" }}>
            {t("pilotstatus.main")}
          </h4>
          <button
            className="add-pilot"
            onClick={() => {
              setSearchPilot(true);
              // findPilot();
            }}
          >
            <h4 style={{ margin: "0" }}>{t('pilotstatus.addpilot')}</h4>
          </button>
        </div>
        <Table striped bordered={false} hover className="table-main">
          <thead>
            <tr style={{ paddingTop: "20px", height: "80px" }}>
              <th style={{ width: "10%" }}>{t('pilotstatus.list')}</th>
              <th style={{ width: "20%" }}>{t('pilotstatus.name')}</th>
              <th style={{ width: "20%" }}>{t('pilotstatus.type')}</th>
              <th style={{ width: "20%" }}>{t('pilotstatus.status')}</th>
              <th style={{ width: "20%" }}>{t('pilotstatus.canclepilot')}</th>
            </tr>
          </thead>

          {portionData.length === 0 ? (
            loading === true ? (
              <thead>
                <th colSpan={6}>
                  <div className="loading-container" style={{ height: "20vh" }}>
                    {" "}
                    <Spinner
                      animation="border"
                      variant="secondary"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                </th>
              </thead>
            ) : (
              <thead>
                <th colSpan={6}>
                  <h4 className="header-main">ไม่พบข้อมูล</h4>
                </th>
              </thead>
            )
          ) : (
            portionData.map((item, index) => {
              return (
                <tbody key={index}>
                  {item.status_text === "ปฏิเสธ" ? (
                    <tr style={{ backgroundColor: "red" }}>
                      <td>{index + 1}</td>
                      <td>{item.pilot_name}</td>
                      <td
                        className="table-space"
                        style={{
                          color: (() => {
                            switch (item.pilot_type) {
                              case "OPEN":
                                return "#008000";
                              case "SPECIFIC":
                                return "#FF8C00";
                              default:
                                return "#FF0000";
                            }
                          })(),
                        }}
                      >
                        {item.pilot_type}
                      </td>
                      <td
                        className="table-space"
                        style={{
                          color: (() => {
                            switch (item.status_text) {
                              case "เข้าร่วม":
                                return "#008000";

                              case "ไม่เข้าร่วม":
                                return "#FF0000";
                              default:
                                return "#FF8C00";
                            }
                          })(),
                        }}
                      >
                        {item.status_text ?? "ติดต่อเจ้าหน้าที่"}
                      </td>
                      <td
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          onClick={() => {
                            console.log("Test");
                            setDeletingSelect([
                              item.pilot_id,
                              item.co_id,
                              item.pilot_name,
                            ]);
                            setShowDeletePilot(true);
                          }}
                          className="custom-btn btnCancel"
                          style={{ fontSize: "16px" }}
                        >
                          X
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr key={item.co_id}>
                      <td>{index + 1}</td>
                      <td>{item.pilot_name}</td>
                      <td
                        className="table-space"
                        style={{
                          color: (() => {
                            switch (item.pilot_type) {
                              case "OPEN":
                                return "#008000";

                              case "SPECIFIC":
                                return "#FF8C00";
                              default:
                                return "#FF0000";
                            }
                          })(),
                        }}
                      >
                        {item.pilot_type}
                      </td>

                      <td
                        className="table-space"
                        style={{
                          color: (() => {
                            switch (item.status_text) {
                              case "เข้าร่วม":
                                return "#008000";

                              case "ไม่เข้าร่วม":
                                return "#FF0000";
                              default:
                                return "#FF8C00";
                            }
                          })(),
                        }}
                      >
                        {item.status_text ?? "ติดต่อเจ้าหน้าที่"}
                      </td>
                      <td
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <button
                          //disabled
                          onClick={() => {
                            console.log("Test");
                            setDeletingSelect([
                              item.pilot_id,
                              item.co_id,
                              item.pilot_name,
                            ]);
                            setShowDeletePilot(true);
                          }}
                          className="custom-btn btnCancel"
                          style={{ fontSize: "16px" }}
                        >
                          X
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              );
            })
          )}
        </Table>
        <PaginationS
          data={remoteDrone}
          onPortionChange={handlePortionChange}
          searchValue={SearchValue}
        />
      </div>
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      <Modal
        show={showDeletePilot}
        onHide={() => {
          setDeletingSelect([]);
          setShowDeletePilot(false);
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>ยืนยันการลบนักบิน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>คุณยืนยันที่จะลบนักบิน {deletingSelect[2]} หรือไม่</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="custom-btn btnCancel"
            onClick={() => {
              setDeletingSelect([]);
              setShowDeletePilot(false);
            }}
          >
            ยกเลิก
          </Button>
          <Button
            className="custom-btn btnSave"
            onClick={() => {
              deletePilot(deletingSelect[0], deletingSelect[1]);
              setDeletingSelect([]);
              setShowDeletePilot(false);
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        show={searchPilot}
        onHide={() => {
          setSearchPilot(false);
          setIdpilot("");
          setCodepilot("");
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>ผลลัพธ์การค้นหา</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              height: "auto",
            }}
          >
            <h4>หมายเลขนักบิน</h4>
            <input
              style={{
                border: "1px solid black",
                width: "100%",
                paddingLeft: "10px",
                height: "35px",
                fontSize: "20px",
                borderRadius: "10px",
              }}
              onChange={(e) => setIdpilot(e.target.value)}
            ></input>
            <h4>Code นักบิน</h4>
            <input
              style={{
                border: "1px solid black",
                width: "100%",
                paddingLeft: "10px",
                height: "35px",
                fontSize: "20px",
                borderRadius: "10px",
              }}
              onChange={(e) => setCodepilot(e.target.value)}
            ></input>

            <div
              onClick={() => {
                findPilot();
              }}
              style={{
                display: "flex",
                width: "20%",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#B5F1CC",
                height: "50px",
                cursor: "pointer",
                borderRadius: "10px",
                margin: "25px auto 0px auto",
                border: "3px solid black",
              }}
            >
              <h4>ค้นหา</h4>
            </div>
            <div style={{ height: "25px" }}></div>
            {pilotdata != "" ? (
              <Table striped bordered={false} hover>
                <thead>
                  <tr
                    style={{ paddingTop: "20px", height: "80px" }}
                    key={pilotdata.pilot_name}
                  >
                    <th>ชื่อ</th>
                    <th>code นักบิน</th>
                    <th>ประเภทการบิน</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>{pilotdata.pilot_name}</td>
                    <td>
                      {pilotdata.pilot_code_specific ||
                        pilotdata.pilot_code_open}
                    </td>
                    <td>{pilotdata.pilot_type}</td>
                  </tr>
                </tbody>
              </Table>
            ) : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="custom-btn btnCancel"
            onClick={() => {
              setSearchPilot(false);
            }}
          >
            ยกเลิก
          </Button>
          <Button
            className="custom-btn btnSave"
            onClick={() => {
              addpilot();
              setIdpilot("");
              setCodepilot("");
              setSearchPilot(false);
            }}
          >
            เพิ่มนักบิน
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        show={addsuc}
        onHide={() => {
          setSearchPilot(false);
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>ผลลัพธ์การเพิ่มนักบิน</Modal.Title>
        </Modal.Header>
        <Modal.Body>เพิ่มนักบินเรียบร้อย</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setSearchPilot(false);
            }}
          >
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={checkope}
        onHide={() => {
          setCheckope(false);
        }}
        className="font-cen"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ท่านยังไม่ได้ขึ้นทะเบียนโดรน หรือ โดรนของท่านยังไม่ได้รับการอนุมัติ{" "}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              Navigate("/user/drone/regisDrone");
            }}
          >
            หน้าขึ้นทะเบียนโดรน
          </Button>
          <Button
            onClick={() => {
              Navigate("/user/drone/statusDrone");
            }}
          >
            หน้าสถานะการขึ้นทะเบียน
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={errorpilot}
        onHide={() => {
          setErrorpilot(false);
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>{dataerror}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setErrorpilot(false);
            }}
          >
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={yes_error}
        onHide={() => {
          setYes_error(false);
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>กรุณาใส่ข้อมูลให้ถูกต้อง</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setYes_error(false);
            }}
          >
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PilotStatus;
